import { Component, Input, Output, EventEmitter, OnChanges, SimpleChanges, OnDestroy } from '@angular/core';
import { Chart, ChartDataSets, ChartOptions, ChartSize, ChartType } from 'chart.js';
import { Label } from 'ng2-charts';
import DataLabelsPlugin from 'chartjs-plugin-datalabels';
import { _drawRoundedEdges } from 'src/app/shared/utils/extends/ng2-chartjs/chart-round';
import { graficoRendimiento } from 'src/app/services/consultas/mis-rendimiento/rendimiento.model';
import { BreakpointObserver, BreakpointState } from '@angular/cdk/layout';
import { Subscription } from 'rxjs';
import { fnFormatoNumMiles, fnFormatoNumAbrev } from 'src/app/shared/utils/functions/general';

@Component({
  selector: 'app-grafico-rendimientos',
  templateUrl: './grafico-rendimientos.component.html',
  styleUrls: ['./grafico-rendimientos.component.scss']
})
export class GraficoRendimientosComponent implements OnChanges, OnDestroy {
  @Input() listaData: graficoRendimiento[] = [];
  @Input() monedaIn: string = "";
  @Output() eDetalle = new EventEmitter<any>();

  chartType: ChartType = "bar";
  //chartPlugins = [DataLabelsPlugin];
  chartLegend = false;
  chartData: ChartDataSets[] = [];
  chartLabels: Label[] = [];
  chartOptions: ChartOptions = {};

  dataInit: graficoRendimiento[] = [];
  dataGrafico: [string[], number[], number[], number[], string[], string[]];
  isMobil: boolean = false;
  isMobilFirst: boolean = true;
  movilSubcrip: Subscription;
  minX: number = 0;
  maxX: number = 0;
  valPxMovil: number = 420;
  tooltipEl = document.getElementById("tooltip");

  constructor(private breakpointObserver: BreakpointObserver) {
    Chart.defaults.global.defaultFontFamily = "'fs_sura_sans_regular', normal";
    Chart.elements.Rectangle.prototype.draw = _drawRoundedEdges;
    this.movilSubcrip = this.breakpointObserver.observe(['(max-width: 420px)']).subscribe((state: BreakpointState) => {
      if (this.isMobilFirst) {
        this.isMobil = state.matches;
        this.isMobilFirst = false;
      }
    });

    // Crear el contenedor del tooltip
    let tooltipEl = document.getElementById('chartjs-tooltip');
    if (!tooltipEl) {
      tooltipEl = document.createElement('div');
      tooltipEl.id = 'chartjs-tooltip';
      tooltipEl.classList.add('tooltipCharjs');
      tooltipEl.innerHTML = '<section class="tooltipCharjs-main"></section>';
      document.body.appendChild(tooltipEl);
    }
  }

  ngOnDestroy(): void {
    document.querySelector(".tooltipCharjs-main").removeAllListeners();
    this.movilSubcrip.unsubscribe();
  }

  ngOnChanges(_changes: SimpleChanges): void {
    document.querySelector(".tooltipCharjs-main").removeAllListeners();
    document.querySelector(".tooltipCharjs-main").addEventListener('click', ($event) => {
      const auxNum = $event.srcElement["dataset"].id;
      if (auxNum) this.verDetalle(auxNum);
    })
    this.dataInit = [];
    this.dataInit = [...this.listaData];
    this.dataGrafico = this.adpaterDataGrafico(this.dataInit);
    let auxMax = Math.max(...this.dataInit.map(x => x.variacion));
    this.maxX = auxMax > 100 ? Math.max(...this.dataInit.map(x => x.variacion)) * 1.00 : 1000;

    let auxMin = Math.min(...this.dataInit.map(x => x.aporte));
    this.minX = auxMin > 0 ? auxMin * 0.90 : 0;
    this.initOptions();
    this.armarGrafico();
  }

  adpaterDataGrafico = (data: graficoRendimiento[]): [string[], number[], number[], number[], string[], string[]] => {
    let listaLabel: any[] = [];
    let listaSerieA: number[] = [];
    let listaSerieB: number[] = [];
    let listaSerieC: number[] = [];
    let colorSerieC: string[] = [];
    let colorHoverSerieC: string[] = [];
    data.forEach(x => {
      listaLabel.push(x.fecha);
      listaSerieA.push(x.linea);
      listaSerieB.push(x.aporte);
      listaSerieC.push(x.variacion);
      colorSerieC.push(x.colorSerie);
      colorHoverSerieC.push(x.colorSerie);
    });
    return [listaLabel, listaSerieA, listaSerieB, listaSerieC, colorSerieC, colorHoverSerieC]
  }

  initOptions() {
    this.chartOptions = {
      onResize: (val: ChartSize) => {
        this.isMobil = val.width < 450;
      },
      responsive: true,
      events: ["mousemove"],

      tooltips: {
        enabled: false,
        mode: "index",
        displayColors: false,
        backgroundColor: "#FFFFFF",
        titleFontColor: "#252323",
        cornerRadius: 8,
        borderColor: "rgba(100, 100, 100, 0.2)",
        borderWidth: 2,
        titleFontSize: 14,
        bodyFontColor: "#252323",
        bodyFontSize: 10,
        footerFontColor: "#003C71",
        footerFontSize: 12,
        footerAlign: 'center',
        filter: (item, _data) => item.datasetIndex !== 0,
        callbacks: {
          beforeTitle: (item, _data) => item[0].index.toString(),
          title: (item, _data) => this.getMontoTitulo(item[0].index),
          afterTitle: (item, _data) => this.getFlechaTitulo(item[0].index),
          label: (tooltipItem, _data) => this.getMontoLabel(tooltipItem.index, tooltipItem.datasetIndex),
          footer: (_item, _data) => "Ver detalle",
          labelColor: (tooltipItem, _chart) => this.getColorLabel(tooltipItem.index, tooltipItem.datasetIndex),
        },
        custom(tooltipModel) {
          let IdColumn = "";
          let tooltipEl = document.getElementById('chartjs-tooltip');
          // Hide if no tooltip
          if (tooltipModel.opacity === 0) {
            tooltipEl.style.opacity = "0";
            return;
          }

          // Set caret Position
          tooltipEl.classList.remove('above', 'below', 'no-transform');
          if (tooltipModel.yAlign) {
            tooltipEl.classList.add(tooltipModel.yAlign);
          } else {
            tooltipEl.classList.add('no-transform');
          }

          function getBody(bodyItem) {
            return bodyItem.lines;
          }

          // Set Text
          if (tooltipModel.body) {
            const footerLines = tooltipModel.footer || [];
            var titleLines = tooltipModel.title || [];
            var bodyLines = tooltipModel.body.map(getBody);

            var innerHtml = '<div class="tooltipCharjs-main-titulos">';

            titleLines.forEach(function (title, i) {
              let auxTit = "";
              let auxFlecha = "";
              if (i === 0) {
                IdColumn = title
              } else if (i === 1) {
                innerHtml += '<div>' + title + '</div>';
              } else {
                innerHtml += '<div class="' + title + '"></div>';
              }
            });
            innerHtml += '</div><div class="tooltipCharjs-main-labels">';

            bodyLines.forEach(function (body, i) {
              var colors = tooltipModel.labelColors[i];
              var style = 'background:' + tooltipModel.backgroundColor;
              style += '; border-color:' + tooltipModel.borderColor;
              style += '; border-width: 2px';
              var span = '<span style="' + style + '"></span>';
              innerHtml += '<div>' + span + body + '</div>';
            });
            innerHtml += '</div>';
            footerLines.forEach(function (title) {
              innerHtml += '<div class="tooltipCharjs-main-footer" data-id="' + IdColumn + '">' + title + '</div>';
            });

            var tableRoot = tooltipEl.querySelector('section');
            tableRoot.innerHTML = innerHtml;
          }

          // `this` will be the overall tooltip
          var position = this._chart.canvas.getBoundingClientRect();
          // Display, position, and set styles for font
          tooltipEl.style.opacity = "1";
          tooltipEl.style.position = 'absolute';
          tooltipEl.style.left = position.left + window.pageXOffset + tooltipModel.caretX + 'px';
          tooltipEl.style.top = position.top + window.pageYOffset + tooltipModel.caretY + 'px';
          tooltipEl.style.fontFamily = tooltipModel._bodyFontFamily;
          tooltipEl.style.fontSize = tooltipModel.bodyFontSize + 'px';
          tooltipEl.style.fontStyle = tooltipModel._bodyFontStyle;
          tooltipEl.style.padding = tooltipModel.yPadding + 'px ' + tooltipModel.xPadding + 'px';
        },
      },
      scales: {
        yAxes: [
          {
            offset: false,
            ticks: {
              // beginAtZero: this.minX > 0 ? false : true,
              beginAtZero: true,
              // autoSkip: true,
              maxTicksLimit: 20,
              // min: 1000,
              suggestedMax: this.maxX,
              suggestedMin: this.minX,
              fontSize: 10,
              callback: (value) => this.getEjeY(value),
            },
          }
        ],
        xAxes: [
          {
            stacked: true,
            ticks: {
              maxRotation: 0,
              beginAtZero: true,
              fontSize: 10,
              callback: (value: any) => this.getEjeX(value),
            },
            gridLines: {
              display: false,
            },
          }
        ]
      },
    };
  }

  armarGrafico() {
    this.chartLabels = this.dataGrafico[0];
    this.chartData = [
      {
        label: "Series Linea",
        data: this.dataGrafico[1],
        type: "line",
        order: 1,
        fill: false,
        backgroundColor: "#003C71",
        hoverBackgroundColor: "#003C71",
        hoverBorderColor: "#003C71",
        borderColor: "#003C71",
        lineTension: 0,
        pointBorderColor: '#003C71',
        pointHoverBorderColor: '#003C71',
        pointBackgroundColor: '#FFFFFF',
        pointHoverBackgroundColor: '#FFFFFF',
        pointBorderWidth: 2,
        pointHoverBorderWidth: 2,
        datalabels: { display: false, },
      },
      {
        label: "Series Black",
        data: this.dataGrafico[2],
        order: 2,
        backgroundColor: "#768692",
        hoverBackgroundColor: "#768692",
        datalabels: { display: false, },
        maxBarThickness: 100,
      },
      {
        label: "Series Var",
        data: this.dataGrafico[3],
        type: "bar",
        order: 3,
        backgroundColor: this.dataGrafico[4],
        hoverBackgroundColor: this.dataGrafico[5],
        datalabels: { display: false, },
        maxBarThickness: 100,
      },
    ];
  }

  getPadding(val: number): number { return val < this.valPxMovil ? 2 : 6 }
  getFontSize(val: number): number { return val < this.valPxMovil ? 8 : 11 }
  getFontWeight(val: number): any { return val < this.valPxMovil ? 'normal' : 'bold' }
  getLineHeight(val: number): number { return val < this.valPxMovil ? 1 : 1.4 }
  getColorRendi(index: number) { return this.dataInit[index].colorRendi }
  getMontoTitulo(index: number): string {
    return this.monedaIn + "" + this.dataInit[index].nom;
  }
  getFlechaTitulo(index: number): string {
    const aux = this.dataInit[index].esVariacion;
    return aux === "S" ? "flechaVerde" : (aux === "N" ? "flechaRoja" : "");
  }
  getMontoLabel(index: number, indexFila: number): string {
    return indexFila === 1 ? this.dataInit[index].variacionCard : this.dataInit[index].aporteCard
  }
  getColorLabel(index: number, indexFila: number): any {
    let auxColor = { borderColor: "transparent", backgroundColor: "" };
    indexFila === 1 ? auxColor.backgroundColor = this.dataInit[index].colorRendiTooltip : auxColor.backgroundColor = "#768692";
    return auxColor;
  }
  getEjeX(value: any): string {
    return this.isMobil ? value : value.join(' ');
  }
  getEjeY(value: any): string {
    return this.isMobil ? this.monedaIn + ' ' + fnFormatoNumAbrev(Number(value)) : this.monedaIn + ' ' + fnFormatoNumMiles(Number(value), 0);
  }
  verDetalle(pos: number) {
    this.eDetalle.emit(this.dataInit[pos].detalle);
  }


}